import { type ReactNode, useMemo } from 'react';

import { TokenBadge } from './TokenBadge';
import { EVENT_NAME_TOKENS } from './tokenTemplate';

interface TokenElementData {
  tokenName: string;
}

interface TokenElementProps {
  attributes: Record<string, unknown>;
  children: ReactNode;
  element: TokenElementData;
}

export function TokenElement({
  attributes,
  children,
  element,
}: TokenElementProps) {
  // Memoise the derived label so identity is stable across re-renders — Plate
  // re-renders inline-void elements frequently as the editor selection changes.
  const label = useMemo(() => {
    const token = EVENT_NAME_TOKENS.find(t => t.name === element.tokenName);
    return token?.label ?? element.tokenName;
  }, [element.tokenName]);

  return (
    <span
      {...attributes}
      contentEditable={false}
      aria-label={`${label} token`}
      className='inline-flex align-middle'
    >
      <TokenBadge label={label} />
      {children}
    </span>
  );
}
